import { addGiftBoxToCartInCart } from '../js/global-exports.js';

/* Handles the checkbox on the items in the cart for adding giftbox to line item */
customElements.define('giftbox-addition', class WishlistPageItems extends HTMLElement {
    constructor() {
        super();
        this.elements = {};
        this.elements.checkbox = this.querySelector('input[type="checkbox"][data-add-giftbox]');
        this.elements.lineItemEl = this.closest('.cart-item');
        this.elements.deleteButton = this.elements.lineItemEl?.querySelector('cart-remove-button');
        this.elements.hrefDelete = this.elements.deleteButton?.querySelector('a[href]')?.getAttribute('href');
        this.lineItemVariantId = parseInt(this.getAttribute('data-lineitem-id'));
        this.giftBoxVariantId = parseInt(this.getAttribute('data-giftbox-id'));
        this.initEvents();
    }

    initEvents() {
      this.addEventListener('change', (e)=>{
        e.stopPropagation();
      });
      this.addEventListener('click', (e)=>{
        e.stopPropagation();
      });

      this.elements.checkbox.addEventListener('click', ()=>{
        this.addGiftBoxToCart();
      });
    }

    async getCartItemsFromServer(lineIndex){
      return await fetch('/cart.js').then(res => res.json()).then(async (cart) => {
        const lineItem = cart.items[lineIndex];

        if(lineItem.id === this.lineItemVariantId){
          return lineItem;
        }
        return null;
      }).catch((error) => {
        this.errorMessage = error;
        console.error('There was an error getting the cart! Reload and try again', error);
      });
    }

    getCurrentLineIndex() {
      const currentCartItemElement = this.closest('.cart-item');
      if(!currentCartItemElement || !currentCartItemElement.id){
        return null;
      }
      return parseInt(currentCartItemElement.id.split('-')[1])-1;
    }

    async addGiftBoxToCart() {
      // disable checkbox
      this.elements.checkbox.setAttribute('disabled','true');

      // show waiting animation or just change styling to disabled
      this.classList.add('cart-item__giftbox-addition--wait');

      // info on the product is saved in a variable/property, so that we keep the correct cart line properties
      const currentLineIndex = this.getCurrentLineIndex();
      if(currentLineIndex === null) {
        console.error('No cart item was found');
        return;
      }

      const lineItemFromServer = await this.getCartItemsFromServer(currentLineIndex);
      if(lineItemFromServer === undefined) {
        console.error('That line item was not found! Reload and try again');
        return;
      }
      const cartObj = [];
      const mainProductObj ={
        id:lineItemFromServer.id,
        quantity:lineItemFromServer.quantity
      }
      if(lineItemFromServer.properties){
        mainProductObj.properties = lineItemFromServer.properties
      }
      const giftBoxObj = {
        id:this.giftBoxVariantId,
        quantity:1,
        parent_id:lineItemFromServer.id
      }
      cartObj.push(mainProductObj,giftBoxObj);

      // existing product is deleted from cart
      await this.removeCurrentProduct();

      // Product is re-added to cart with the gift box as nested cart line and Cart is re-rendered
      addGiftBoxToCartInCart(cartObj);

    }

    async removeCurrentProduct() {
      return await fetch(this.elements.hrefDelete).then(async () => {
        return true;
      }).catch((error) => {
        this.errorMessage = error;
        console.error('There was an error removing the product', error);
        return false;
      });
    }
});

